import {MotorMakeList} from "./MotorMakeList";
import {MotorMakeEdit} from "./MotorMakeEdit";
import {MotorMakeCreate} from "./MotorMakeCreate";

export default {
    list: MotorMakeList,
    create: MotorMakeCreate,
    edit: MotorMakeEdit
};
